/** Normaliza texto para búsqueda (minúsculas, sin diacríticos). */
export function normalizeSearchText(value: string | null | undefined): string {
  return (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

/** `lacteos` encuentra `Lácteos`. Query vacío = match. */
export function matchesSearchText(value: string | null | undefined, query: string): boolean {
  const q = normalizeSearchText(query);
  if (!q) return true;
  return normalizeSearchText(value).includes(q);
}

export function matchesSearchAny(values: Array<string | null | undefined>, query: string): boolean {
  const q = normalizeSearchText(query);
  if (!q) return true;
  return values.some((value) => normalizeSearchText(value).includes(q));
}

/**
 * Variantes para OR en ilike remoto (sin extensión unaccent):
 * "lopez" → lopez, lópez.
 */
export function accentQueryVariants(raw: string): string[] {
  const base = normalizeSearchText(raw);
  if (!base) return [];
  const out = new Set<string>([base]);
  const pairs: Array<[string, string]> = [
    ['a', 'á'],
    ['e', 'é'],
    ['i', 'í'],
    ['o', 'ó'],
    ['u', 'ú'],
    ['n', 'ñ'],
  ];
  for (const [plain, accented] of pairs) {
    if (base.includes(plain)) {
      out.add(base.split(plain).join(accented));
    }
  }
  return Array.from(out);
}

/** Expresión SQL SQLite: LOWER + quitar acentos comunes (alineado a búsqueda de productos). */
export function buildAccentInsensitiveSqlExpression(column: string): string {
  // LOWER después de reemplazos; incluye minúsculas acentuadas (SQLite LOWER no pliega bien ñ/ü).
  return `LOWER(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(${column}, 'Á', 'A'), 'É', 'E'), 'Í', 'I'), 'Ó', 'O'), 'Ú', 'U'), 'Ü', 'U'), 'Ñ', 'N'), 'á', 'a'), 'é', 'e'), 'í', 'i'), 'ó', 'o'), 'ú', 'u'), 'ü', 'u'), 'ñ', 'n'))`;
}

/** `AND (fold(col) LIKE ? OR …)` para búsquedas SQLite. */
export function buildAccentInsensitiveLikeClause(
  columns: string[],
  search?: string | null,
): { clause: string; params: string[] } {
  const term = normalizeSearchText(search);
  if (!term || columns.length === 0) return { clause: '', params: [] };
  const like = `%${term}%`;
  const parts = columns.map((column) => `${buildAccentInsensitiveSqlExpression(column)} LIKE ?`);
  return { clause: ` AND (${parts.join(' OR ')})`, params: columns.map(() => like) };
}
